import type React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { Button, Typography } from '@components/ui'

import { KpiSkeletonBox, SkeletonBox } from './styles'

const LoadingWrapperSection = styled.section`
  height: 57px;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.common.paperStroke};
  display: flex;
  gap: 20px;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.gray[0]};
  border-radius: 4px;

  & + & {
    margin-top: 20px;
  }
`

export enum ReportLayouts {
  ACCORDION = 'accordion',
  ASYNC_ACCORDION_OPEN = 'asyncAccordionOpen',
  THREE_COLUMN_WIDGET = 'threeColumnWidget',
  TWO_COLUMN_WIDGET = 'twoColumnWidget',
}
export interface LoadingReportProps {
  layout?: ReportLayouts
  name?: React.ReactNode
}

export function LoadingReportError({ name, retry }: { name: React.ReactNode; retry: VoidFunction }) {
  return (
    <LoadingWrapperSection>
      <Typography color="error" size="400-md">
        <FormattedMessage
          id="pulse.report.error"
          defaultMessage="Sajnáljuk, a(z) {name} betöltése nem sikerült. <button>Próbáld meg újra!</button>"
          values={{
            name,
            button: (chunks: React.ReactNode) => (
              <Button onClick={retry} size="small" variant="secondaryText">
                {chunks}
              </Button>
            ),
          }}
        />
      </Typography>
    </LoadingWrapperSection>
  )
}

export function LoadingReport({ layout }: LoadingReportProps) {
  switch (layout) {
    case ReportLayouts.THREE_COLUMN_WIDGET:
      return (
        <KpiSkeletonBox as="section">
          <SkeletonBox as="article" />
          <SkeletonBox as="article" />
          <SkeletonBox as="article" />
        </KpiSkeletonBox>
      )
    case ReportLayouts.TWO_COLUMN_WIDGET:
      return (
        <KpiSkeletonBox as="section">
          <SkeletonBox as="article" />
          <SkeletonBox as="article" />
        </KpiSkeletonBox>
      )
    case ReportLayouts.ASYNC_ACCORDION_OPEN:
      return <SkeletonBox $height={160} as="section" />
    case ReportLayouts.ACCORDION:
    default:
      return <SkeletonBox as="section" />
  }
}
